/**
 * Canonical card-type display order — Unit → Spell → Gear, then everything else.
 *
 * Framework-free so the same rank is used by:
 *   - `src/utils/cardUtils.ts` (client catalog / deck-list sort)
 *   - `src/components/deck/deckListSort.ts` (deck-list Type headings)
 *   - `api/_shared/cardCache.js` (cards.search ORDER BY)
 *
 * Keep this the only place the Type rank is defined. The SQL CASE is generated
 * from the same array so it cannot drift from the JS comparator.
 */
export const CARD_TYPE_SORT_ORDER = ['Unit', 'Spell', 'Gear', 'Other'];

export function cardTypeSortRank(cardType) {
  const type = cardType || 'Other';
  const idx = CARD_TYPE_SORT_ORDER.indexOf(type);
  return idx === -1 ? CARD_TYPE_SORT_ORDER.length : idx;
}

/**
 * SQL CASE that ranks `column` the same way as `cardTypeSortRank`.
 * Named types get 0..n-2; unknown / Other share the last rank.
 *
 * @param {string} [column='card_type']
 */
export function cardTypeRankSql(column = 'card_type') {
  const named = CARD_TYPE_SORT_ORDER.filter((t) => t !== 'Other');
  const whens = named.map((t, i) => `WHEN '${t}' THEN ${i}`).join('\n    ');
  return `CASE ${column}\n    ${whens}\n    ELSE ${named.length}\n  END`;
}
